import { useQuery } from "@tanstack/react-query";

import { workspaceService } from "../services/workspaceService";

export const WORKSPACE_QUERY_KEYS = {
  list: ["workspace", "list"] as const,
} as const;

export const useWorkspaces = () => {
  return useQuery({
    queryKey: WORKSPACE_QUERY_KEYS.list,
    queryFn: workspaceService.getWorkspaces,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  });
};
